<template>
  <Photos year="2013" :min-date="1363651200" :max-date="1363910400" date-text="March 19&ndash;22" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
